
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
const Layout = () => import('@/views/Layout.vue') // 公共页面布局
const Word = () => import('@/views/Word/DocEditor.vue') // 编辑器测试页面
const Excel = () => import('@/views/Excel/ExcelEditor.vue') // excel页面
const WordLayout = () => import('@/views/WordLayout.vue') // 公共页面布局
const CreateDoc = () => import('@/views/Others/CreateDoc.vue') // 新建文档
const ExportFile = () => import('@/views/Others/ExportFile.vue') // 新建文档
const ExcelSave = () => import('@/views/Others/ExcelSave.vue') // excel自动保存后端请求页面
const MarkerPage = () => import('@/views/Others/MarkerPage.vue') // 预览页，加水印
const LongforDoc = () => import('@/components/LongforDoc.vue')
const ByTempAddDoc = () => import('@/views/Others/ByTempAddDoc.vue') // word模板页面
const PreviewDocPage = () => import('@/views/Others/PreviewDocPage.vue') // word预览页面
const ResolveExcelToJson = () => import('@/views/Others/resolveExcelToJson.vue') // 导入页面
const MergeExcelData = () => import('@/views/Excel/ExcelEditorCom/MergeExcelData.vue') // 合并多个excel数据页面

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:catchAll(.*)',
    name: 'anyPage',
    component: Layout,
    redirect: { name: 'home' },
    children: []
  },
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    children: [
      {
        path: 'excel/:xlsId',
        name: 'excel',
        component: Excel
      }
    ]
  },
  {
    path: '/',
    name: 'WordLayout',
    component: WordLayout,
    children: [
      {
        path: '',
        name: 'home',
        component: Word
      },
      {
        path: 'word/:docId',
        name: 'word',
        component: Word
      }
    ]
  },
  {
    path: '/markerPage/:url',
    name: 'MarkerPage',
    component: MarkerPage
  },
  {
    path: '/createDoc',
    name: 'CreateDoc',
    component: CreateDoc
  },
  {
    path: '/printpreview/',
    name: 'ExportFile',
    component: ExportFile
  },
  {
    path: '/excelSave/:xlsId',
    name: 'ExcelSave',
    component: ExcelSave
  },
  {
    path: '/longforDoc',
    name: 'LongforDoc',
    component: LongforDoc
  },
  {
    path: '/byTempAddDoc',
    name: 'ByTempAddDoc',
    component: ByTempAddDoc
  },
  {
    path: '/previewDocPage',
    name: 'PreviewDocPage',
    component: PreviewDocPage
  },
  {
    path: '/resolveExcelToJson',
    name: 'ResolveExcelToJson',
    component: ResolveExcelToJson
  },
  {
    path: '/MergeExcelData',
    name: 'MergeExcelData',
    component: MergeExcelData
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
